import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function ContactDialog({ open, onOpenChange }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    if (message.trim().length < 2) return;
    setLoading(true);
    try {
      await api.post("/contact", { message });
      toast.success("Mesajın yöneticiye iletildi.");
      setMessage("");
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-950/95 backdrop-blur-xl border-slate-800 text-slate-100 sm:max-w-md" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Yöneticiye Yaz</DialogTitle>
          <DialogDescription className="text-slate-400">Mesajın doğrudan admin paneline düşer.</DialogDescription>
        </DialogHeader>
        <Textarea data-testid="contact-message-input" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Mesajını yaz..." className="cx-input min-h-[120px] h-auto" />
        <Button data-testid="contact-send-button" onClick={send} disabled={loading || message.trim().length < 2} className="cx-btn-primary rounded-xl h-11">
          {loading ? "Gönderiliyor..." : "Gönder"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
